const components = {
  // SDoc
  rmDocTip: "你想刪除這個檔案嗎？刪除後無法恢復。",
  searchPlaceholder: '搜尋檔案或資料夾',
  upload: '上傳',
  newFolder: '新建資料夾',
  folderNamePlaceholder: '請輸入資料夾名稱',
  cannotMoveToChild: '不能移動到子資料夾',
  moveSuccess: '移動成功',
  moveFail: '移動失敗',
  moveToParent: '移動到上一層',
  move: '移動',
  moveTitle: '移動',
  moving: '正在移動: {{name}}',
  currentLocation: '當前位置',
  rootDirectory: '根目錄',
  noFolders: '暫無資料夾',
  moveToHere: '移動到此處',
  cancel: '取消',

  // Dict
  plDictName: "請輸入名稱",
  plDictDesc: "請輸入描述",
  dictName: "名稱",
  dictDesc: "描述",

  // Selector
  plCountry: "請選擇國家/地區",
  plCreditLevel: "請選擇信用等級",
  plCurrency: "請選擇幣種",
  plProduct: "請選擇商品",

  // 详情弹窗
  plContent: '請輸入內容',
  send: '發送',
  reply: '回覆',
  replyTo: '回覆 {{name}}',
  cancelReply: '取消回覆',
  replyCount: '{{name}} 則回覆',
  collapseReplies: '收起回覆',
  cameraUpload: "拍照上傳",
  takePhoto: "拍照",
  switchCamera: "切換攝像頭",
};

export default components;
